export enum LicenceType {
  Concurrent = "Concurrent",
  SingleUser = "SingleUser",
  Trial = "Trial",
  API = "API",
}
